const uploadMessage = {
  click: 'Haga clic o arrastre archivos aquí...',
  error: 'Archivo no soportado',
  success: 'Suelte los archivos aquí'
};

export default uploadMessage;
